module.exports = __webpack_public_path__ + "static/media/t3-img1.e0dfa009.png";